<template>
  <router-view />

  <!-- Credits -->
  <div id="creditsmodal" class="modal">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Ringraziamenti</p>
      </header>
      <section class="modal-card-body">
        <a @click="openUrl('https://fontawesome.com/')"
          >Font Awesome Free 5.15.4 by @fontawesome</a
        >
        -
        <a @click="openUrl('https://fontawesome.com/license/free')">License</a>
        - (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
        <br />
        <a @click="openUrl('https://bulma.io/')">Bulma 5.15.4 by @jgthms</a> -
        <a
          @click="
            openUrl(
              'https://raw.githubusercontent.com/jgthms/bulma/master/LICENSE'
            )
          "
          >License</a
        >
        - (MIT License)
        <br />
        <a @click="openUrl('https://v3.vuejs.org/')">VueJS v3 by @vuejs</a> -
        <a
          @click="
            openUrl('https://raw.githubusercontent.com/vuejs/vue/dev/LICENSE')
          "
          >License</a
        >
        - (MIT License)
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="closemodal('creditsmodal')">
          Chiudi
        </button>
      </footer>
    </div>
  </div>

  <!-- Privacy Policy -->
  <div id="privacymodal" class="modal">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Politiche sulla Privacy</p>
      </header>
      <section class="modal-card-body">
        <b>Questo sito non raccoglie, nè condivide alcun dato personale.</b>
        <br />
        <p>
          Opzionalmente, se decidi di installarlo, oppure di "aggiungerlo alla
          schermata home", il tuo browser scaricherà i contenuti statici
          (immagini, titoli, codici e descrizioni dei tè) per permetterti di
          usare il sito offline, nota che questo non è necessario per il
          funzionamento del sito, tuttavia se decidi di bloccare i cookie,
          dovrai usare per forza l'applicazione solo se sei online.
        </p>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="closemodal('privacymodal')">
          Chiudi
        </button>
      </footer>
    </div>
  </div>

  <!-- Contatti -->
  <div id="contactsmodal" class="modal">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Contatti</p>
      </header>
      <section class="modal-card-body">
        <a
          id="emailbc"
          @click="
            openUrl(
              'mailto:info@chazen.it?subject=[Chazen]%20Richiesta%20Informazioni'
            )
          "
          tooltip="Invia e-mail"
          flow="right"
          >Manda una Mail</a
        ><br />
        <a @click="openUrl('tel:393334444925')"
          >Parla con noi al Telefono 393334444925</a
        ><br />
        <a
          id="facebookbc"
          target="_blank"
          @click="openUrl('https://m.me/chazen.it?ref=')"
          tooltip="Parla con noi su Facebook"
          flow="right"
          rel="noopener"
          >Parla con noi su Facebook</a
        ><br />
        <a
          id="whatsappbc"
          target="_blank"
          @click="
            openUrl(
              'https://web.whatsapp.com/send?phone=393334444925&amp;text='
            )
          "
          tooltip="Parla con noi su Whatsapp"
          flow="right"
          rel="noopener"
          >Parla con noi su Whatsapp</a
        >
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="closemodal('contactsmodal')">
          Chiudi
        </button>
      </footer>
    </div>
  </div>

  <!-- Bottom Menu -->
  <div id="bottom_menu">
    <div class="linksmenu">
      <a @click="openmodal('creditsmodal')">Ringraziamenti</a>
      • <a @click="openmodal('privacymodal')">Politiche sulla Privacy</a> •
      <a @click="openmodal('contactsmodal')">Contatti</a> •
      <a @click="openUrl('https://chazen.it')">Visita Sito</a>
    </div>
    <div class="copyright">
      © 2020-2021 Chazen.it
    </div>
  </div>
</template>

<style lang="scss">
@font-face {
  font-family: "OpenSansRegular";
  src: url("assets/opensans/OpenSans-Regular.ttf");
}

@font-face {
  font-family: "OpenSansItalic";
  src: url("assets/opensans/OpenSans-Italic.ttf");
}

@font-face {
  font-family: "OpenSansBold";
  src: url("assets/opensans/OpenSans-Bold.ttf");
}

@font-face {
  font-family: "OpenSansBoldItalic";
  src: url("assets/opensans/OpenSans-BoldItalic.ttf");
}

body {
  font-family: OpenSansRegular, sans-serif !important;
}

button {
  width: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0.5rem;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
  }
}

#bottom_menu {
  font-size: 10pt;
  width: 95%;
  bottom: 0px;
  margin: 0.5rem auto;
}

.modal-card,
.modal-content {
  margin: auto 5rem !important;
}
</style>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  mounted() {
    //window.addEventListener("scroll", this.reloadBottomMenu);
    window.onbeforeunload = function() {
      return "Sei sicuro di voler uscire?";
    };
  },
  methods: {
    closemodal(modalid: string) {
      if (modalid != null) {
        document!.getElementById(modalid)!.classList.value = "modal";
      }
    },
    openmodal(modalid: string) {
      if (modalid != null) {
        document!.getElementById(modalid)!.classList.value += " is-active";
      }
    },
    openUrl(url: string) {
      window.open(url!, "");
    },
    reloadBottomMenu() {
      document.getElementById("bottom_menu")!.style.display = "none";
      document.getElementById("bottom_menu")!.style.position = "inherit";
      document.getElementById("bottom_menu")!.style.bottom = "0px";
      document.getElementById("bottom_menu")!.style.display = "block";
    }
  }
})
export default class App extends Vue {}
</script>
